const Isotope = require('isotope-layout');

const Filter = (() => {
    const DOM = {};

    const cacheDOM = () => {
        DOM.layoutContainer = document.getElementsByClassName('post-list__content')[0];
    };

    const renderLayout = () => {
        new Isotope( DOM.layoutContainer, {
            // options...
            itemSelector: '.post-list__item',
            percentPosition: true,
            masonry: {
                // use outer width of grid-sizer for columnWidth
                columnWidth: '.post-list__grid-sizer'
            }
        });
    }

    const eventListeners = () => {
        window.addEventListener('load', renderLayout);
    }

    const init = () => {
        cacheDOM();

        if ( DOM.layoutContainer ) {
            eventListeners();
        }
    };

    return {
        init
    };
})();

export default Filter;
